var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.products.length)?_c('div',{staticClass:"container-fluid"},[_c('h3',{staticClass:"section-title"},[_vm._v("\n        Вы смотрели\n    ")]),_vm._v(" "),(_vm.products.length)?_c('product-carousel',{attrs:{"classes":_vm.classes,"items":_vm.products}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }